import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicColorUpdate as SchemaCharacteristicColorUpdate } from '../schemas/CharacteristicColorUpdate';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const UpdateCharacteristicColorsContentType = 'application/json' as const;
export type UpdateCharacteristicColorsRequest = SchemaCharacteristicColorUpdate[];
export type UpdateCharacteristicColorsResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful update of characteristic colors
     */
    '200': {};
};
export type UpdateCharacteristicColorsResponseSuccess = undefined;
export type UpdateCharacteristicColorsSearchParams = undefined;
export type UpdateCharacteristicColorsPathParameters = undefined;
export const UpdateCharacteristicColorsUrl = '/characteristics/colors' as const;
export const UpdateCharacteristicColorsMethod = 'PUT' as const;
export const getUpdateCharacteristicColorsUrl = (_params?: UpdateCharacteristicColorsPathParameters) =>
    UpdateCharacteristicColorsUrl;
